"use client"

import { usePathname } from "next/navigation"
import PropTypes from "prop-types"

import { Paragraph } from "@/components/Paragraph"
import { useSideNavConfig } from "@/providers/sideNavConfig"

import { Button, TextSection } from "./styled"

export const NavigationItem = ({
  children,
  title,
  subtitle,
  additional,
  secondary,
  isHome,
  includedPaths,
  testId,
  ...props
}) => {
  const pathname = usePathname()

  const isActive = isHome
    ? pathname === props?.href
    : pathname.includes(props?.href) || includedPaths?.find((path) => pathname.includes(path))
  const { sideNavOpen } = useSideNavConfig()

  return (
    <Button primary={isActive} fullwidth $additional={additional} secondary={secondary} data-testid={testId} {...props}>
      {children}
      {sideNavOpen && (
        <TextSection $additional={additional || secondary}>
          {title && (
            <Paragraph
              text={title}
              highlight={isActive}
              large={!additional && !secondary}
              small={secondary}
              bold={secondary}
            />
          )}
          {subtitle && <Paragraph text={subtitle} highlight={isActive} xs />}
        </TextSection>
      )}
    </Button>
  )
}

NavigationItem.propTypes = {
  /** Used for adding an icon */
  children: PropTypes.node,
  /** Defines the title for the opened navigation */
  title: PropTypes.string,
  /** Defines the subtitle for the opened navigation */
  subtitle: PropTypes.string,
  /** If true, the navigation button is displayed smaller */
  additional: PropTypes.bool,
  /** If true, the navigation button is displayed with secondary styles */
  secondary: PropTypes.bool,
  /** Test ID for automated testing */
  testId: PropTypes.string,
}
